import { actions as shopActions } from '~/sites/shop/store/banner'
import gql from 'graphql-tag'

const getHomepageBannersQuery = (includeMobileImage = false) => {
  const mobileImageField = includeMobileImage
    ? `
        main_image_mobile {
          path
          alt
        }
      `
    : ''

  return gql`
    query {
      banner_wide(filters: { enabled: true }) {
        entities {
          banner_wide_button_text
          banner_wide_text
          banner_wide_text_2
          main_image {
            path
            alt
          }
          main_image_translatable {
            path
            alt
          }
          ${mobileImageField}
          title
          url
          weight
          time_limited
          time_limit_start
          time_limit_end
        }
      }
    }
  `
}

const processHomepageBanners = data => {
  return data.banner_wide.entities
    .filter(banner => {
      if (!banner.time_limited) {
        return true
      } else if (banner.time_limited && banner.time_limit_start !== null && banner.time_limit_end !== null) {
        return (
          new Date(banner.time_limit_start).valueOf() < Date.now() &&
          Date.now() < new Date(banner.time_limit_end).valueOf()
        )
      }
      return false
    })
    .sort((a, b) => (b.weight || 0) - (a.weight || 0))
}

export const actions = {
  ...shopActions,
  async LOAD_HOMEPAGE_BANNERS() {
    const client = this.app.apolloProvider.defaultClient

    const loadHomepageBanners = async includeMobileImage => {
      const query = await client.query({
        query: getHomepageBannersQuery(includeMobileImage),
      })

      return processHomepageBanners(query.data)
    }

    try {
      return await loadHomepageBanners(true)
    } catch (e) {
      try {
        return await loadHomepageBanners(false)
      } catch (fallbackError) {
        console.error(fallbackError)
      }
    }

    return []
  },
}
